import scroll from "./scroll";

// 自定义指令
const directives = {
  scroll
};

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key]);
    });
  },
};
